import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
// Set page title
document.title = 'Fifth Door';
render(<HelmetProvider data-id="element-129" data-mp="219y01z6xk96f">
    <AppRouter data-id="element-130" data-mp="219ei4iha5kse" />
  </HelmetProvider>, document.getElementById('root'));